import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import MdImage from "../../Assets/Images/mdImage.webp";

const WordsFromDirector = () => {
  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-in-out", once: false, offset: 100 });
    return () => AOS.refresh();
  }, []);

  return (
    <div className="bg-gray-50 px-4 py-10 sm:px-6 lg:px-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        {/* Text Section */}
        <div className="space-y-6" data-aos="fade-right">
          <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold text-gray-900 leading-tight">
            Message from the <span className="text-[#FF5A3C]">Managing Director</span>
          </h1>

          <div className="space-y-4 text-gray-600 text-sm sm:text-base md:text-md leading-relaxed text-justify">
            <p>
              As The Managing Director Of Covenants Developers Pvt. Ltd., I am delighted
              to welcome you to our official website. Whether you are buying, investing,
              or looking for property management solutions, our team is committed to
              delivering exceptional service with integrity and professionalism.
            </p>
            <p>
              With years of experience in the real estate industry, we take pride in
              helping our clients find the perfect property while ensuring a seamless and
              rewarding experience. Explore our listings, discover investment
              opportunities, and let us assist you in making informed real estate
              decisions.
            </p>
          </div>

          <div className="border-l-4 border-[#FF5A3C] pl-4 py-3">
            <p className="text-gray-900 font-semibold text-sm sm:text-base md:text-lg lg:text-xl">
              Thank you for choosing Covenants. We look forward to serving you!
            </p>
          </div>
        </div>

        {/* Image Section */}
        <div className="relative w-full" data-aos="fade-left">
          <div className="relative bg-gray-800 rounded-2xl overflow-hidden shadow-lg">
            <div className="w-full h-full sm:h-80 md:h-96 lg:h-full xl:h-[38rem]">
              <img
                src={MdImage}
                alt="Managing Director"
                className="w-full h-full xl:h-[38rem] object-contain rounded-2xl"
              />
            </div>

            {/* Director Info Card */}
            <div className="absolute bottom-4 left-0 w-[85%] sm:w-[75%]" data-aos="fade-right">
              <div className="bg-white rounded-r-full p-2 md:p-4 lg:p-6 shadow-lg">
                <div className="border-l-4 border-[#FF5A3C] pl-4">
                  <h3 className="text-sm sm:text-md xl:text-xl font-bold text-gray-900 mb-1">
                    Chinmoy Kumar Muduli
                  </h3>
                  <p className="text-xs sm:text-sm text-gray-600">
                    Managing Director of{" "}
                    <span className="text-[#FF5A3C] font-medium">
                      Covenants Developers
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WordsFromDirector;